import { throwApiError } from '@/shared/utils/apiResponse';
import { apiGet } from '@/shared/utils/requestBuilder';
import type { ItemUltimaConversaApi } from '@/types/homeConversas/types';

export const homeConversasService = {
  getMinhasRespondidas: async (params?: {
    limit?: number;
  }): Promise<{
    items: ItemUltimaConversaApi[];
    total: number;
  }> => {
    const response = await apiGet(
      '/conversas/minhas-respondidas',
      params as Record<string, string | number>,
    );
    if (!response.ok) {
      await throwApiError(response, 'Erro ao carregar suas conversas');
    }
    const body = await response.json();
    return (body.data || body) as { items: ItemUltimaConversaApi[]; total: number };
  },
};
